<template>
  <v-card class="my-2">
    <div id="chart">
      <div class="toolbar d-flex align-center justify-space-between mx-3 py-2">
        <SHeader :icon="icon">
          <template v-slot:title>
            <div class="text-button">
              {{ title }}
            </div>
          </template>
        </SHeader>
      </div>
      <div id="chart-timeline">
        <apexchart
          width="100%"
          type="area"
          height="350"
          ref="chart"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "AreaChart",
  props: {
    title: {
      type: String,
      required: true,
    },
    chartData: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#546E7A",
    },
  },
  data: () => ({
    series: [
      {
        data: [],
      },
    ],
    chartOptions: {
      chart: {
        id: "area-datetime",
        type: "area",
        height: 350,
        zoom: {
          autoScaleYaxis: true,
        },
      },
      annotations: {
        xaxis: [
          {
            x: new Date().getTime(),
            borderColor: "#999",
            yAxisIndex: 0,
            label: {
              show: true,
              text: "Aujourd'hui",
              style: {
                color: "#fff",
                background: "#775DD0",
              },
            },
          },
        ],
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: "hollow",
      },
      xaxis: {
        type: "datetime",
        min: new Date("01 Jan 2022").getTime(),
        tickAmount: 6,
      },
      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
    },
  }),
  watch: {
    chartData() {
      this.chartOptions = {
        xaxis: {
          type: "datetime",
          min: this.chartData[0][0],
          tickAmount: 6,
        },
      };
    },
  },
  created() {
    this.chartOptions.colors = [this.color];
    this.chartOptions.xaxis.min =
      this.chartData[0][0] || new Date("01 Jan 2022").getTime();
    this.series[0].data = this.chartData;
  },
};
</script>

<style scoped></style>
